import React from 'react';

import S from './styles';

function FooterActions({ children }) {
  return <S.FooterActions>{children}</S.FooterActions>;
}

export default FooterActions;
